import { useEffect, useState } from 'react';

/**
 * False during server rendering and on the first client render, true after.
 *
 * The public pages are prerendered and then hydrated, so the first client render
 * has to produce exactly the markup the server produced. Entry animations write
 * inline styles, which would break that — so they wait one tick, which is also
 * when the page becomes interactive.
 */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  return hydrated;
}
